<!-- 最小流量分析详情 -->
<template>
  <j-modal
    :title="title"
    width="45%"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :body-style="{ height: '380px', overflow: 'hidden', overflowY: 'scroll' }"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('流量区间最小值')" prop="minFlow">
                <a-input-number v-model="model.minFlow" :placeholder="$t('请输入流量区间最小值')" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('流量区间最大值')" prop="maxFlow">
                <a-input-number v-model="model.maxFlow" :placeholder="$t('请输入流量区间最大值')" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('数字符号')" prop="symbol">
                <j-dict-select-tag :placeholder="$t('请选择数字符号')" dictCode="symbol" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('变化幅度(%)')" prop="changeAmplitude">
                <a-input-number v-model="model.changeAmplitude" :placeholder="$t('请输入变化幅度')" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('报警颜色')" prop="alarmColor">
                <el-color-picker v-model="model.alertColor" size="small"></el-color-picker>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>
            
<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
export default {
  name: 'model2',
  components: {JDictSelectTag},
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      url: {
        getCount: '/jeecg-charge/meterInspectionRecord/getCount',
      },
    }
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {},
    handleCancel() {
      this.close()
    },
  },
}
</script>
          <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
</style>